

exports.__esModule = true;
var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
    return VALID_DIRECTION.includes(n);
};

define(['jquery', 'squid/index', 'text!./template.html', 'xo-ui-components/src/accessibility/directive'], function ($, squid, template) {
    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).directive('xoLanguageOptions', function () {
        return {
            template: template,

            scope: {
                direction: '@'
            },

            controller: function controller($scope, $populate, $locale, $Class, $config, $meta) {
                $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
                $scope.showLanguages = false;

                function setLanguageVars() {
                    $scope.localeModel = $locale;
                    $scope.currentLanguage = $scope.localeModel.lang;
                    $scope.currentCountry = $scope.localeModel.country;
                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
                    $scope.supportedLanguages = $config.supportedCountries[$scope.currentCountry];
                    $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
                }

                $scope.selectLanguage = function (language) {
                    $scope.currentLanguage = language;
                    $locale.chooseLang(language);
                };

                $scope.toggle = function ($event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    $scope.showLanguages = !$scope.showLanguages;
                };

                setLanguageVars();

                // Reset locale properties for languageToggle
                $scope.$on('localeChange', function () {
                    setLanguageVars();
                });

                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
                $scope.$on('clickBody', function ($event, target) {
                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
                        $scope.showLanguages = false;
                        $scope.$apply();
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/language-options/directive.js
// module id = ./components/xo-form-components/src/language-options/directive.js
// module chunks = 1